module.exports = __webpack_public_path__ + "img/Sudoeste.cf39ca6c.svg";